function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h240v240H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6 44)",
  stroke: "#371447",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 53,
  r: 5
}), /*#__PURE__*/React.createElement("rect", {
  x: 83.5,
  y: 29.5,
  width: 47,
  height: 6,
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.023 67.09c-.041 2.727-.161 5.394-.411 7.995C167.07 91.153 160.582 104.681 137 114c-.1-.178.048 1.241 0 12.807-.03 7.333-24.324 7.333-24.344 0V114H88.769l.106 12.807c-.38 7.324-24.663 7.342-24.583 0V114c-20.74-1.582-33.414-8.113-40.019-24.53-.386.035-4.526.024-12.977 0C4.366 90.356.843 85.158.728 73.876.613 62.594 3.405 56.379 9.103 55.229h11.404C26.287 37.31 35.02 26.103 55 21c.06-4.098-.091-18.66 0-20.83C71.223-.21 77.5 7.928 77.5 21c35.962.062 15.185-.156 42.75 0 14.5.082 26.626 4.995 35.188 13.756"
})), /*#__PURE__*/React.createElement("path", {
  d: "M121.515 112.535c-2.23 1.868-3.809 4.225-4.568 6.92-2.57 11.103-8.05 15.568-19.725 14.844 16.904 18.255 39.343 17.027 50.51-.339 1.545-2.401-2.074-10.84-9.092-10.133-25.611 2.575-15.237-12.874-17.125-11.292z",
  fill: "#43A047"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.892 108.633l8.246 9.018 79.188-58.355c.128-.094.254-.19.377-.29 4.482-3.63 5.173-10.206 1.544-14.688a9.55 9.55 0 00-.288-.34c-3.83-4.339-10.453-4.751-14.79-.92l-74.277 65.575zM112 144.675c14.634.234 23.887-4.196 27.76-13.289M169.436 87c6.28 6.225 6.53 11.413 6.652 12.692",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.453 133.627c2.453 3.772 16.805 19.768 35.697 11.484 12.594-5.523 18.16-14.457 16.695-26.8l-7.894-9.295c-11.983-1.994-19.454-.066-22.413 5.784-10.988 21.725-10.554 18.186-22.085 18.827z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -282.26 185.631)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -292.322 200.328)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -300.019 216.39)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -295.019 235.05)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -290.019 253.71)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -248.43 272.638)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 16,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 8,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 24,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 30,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -269.688 292.263)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -275.019 309.691)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -270.019 328.351)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -265.019 347.012)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -256.286 364.672)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
}))));

function SvgMakeYourOwnXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMakeYourOwnXl;